import { resetClipboardStubOnView } from "@testing-library/user-event/dist/cjs/utils/index.js";

export const apiVersion = 'v1';

/* 
**** IMPORTANT ****
For the api to work correctly within the rest of the SARA interface, there should not be a root to the URL, it should just be a '/'
For local development purposes, change the value below inside of the IF statement to the URL necessary for your local development. 
*/

//console.log(`baseUrl=${window.ENV?.baseUrl}`)
//console.log(`window.token=${window.token}`)
let baseUrl = window.ENV?.baseUrl || '/api/';
console.log("api baseUrl=" + baseUrl)

// the official url structure is [baseUrl]/api/[apiVersion]/[endpoint]
// ***NOTE***: the baseUrl will just be / in production
// This file will be kept updated as the api is updated to ensure that any endpoints needed are hitting the correct urls

export const apiUrls = {
  baseUrl,
  v1: {
    login: '/login/',
    currentUser: '/user/current/',
    updatepassword: '/updatepassword/',
    alarmlog: '/alarmlog/',
    panicbuttons: '/panicbuttons/',
    alertdetails: '/alertdetails/',
    alertgroup: '/alertgroup/',
    parentalertgroup: '/parentalertgroup/',
    alertmsglog: '/alertmsglog/',
    usercheckinprofile: '/usercheckinprofile/',
    unitcheckinprofile: '/unitcheckinprofile/',
    alarmdevice: '/alarmdevice/',
    alarmdevicetype: '/alarmdevicetype/',
    alertdevice: '/alertdevice/',
    alertdeviceaccess: '/alertdeviceaccess/',
    alertdevicecategory: '/alertdevicecategory/',
    alertdevicetype: '/alertdevicetype/',
    deviceassociation: '/deviceassociation/',
    mode: '/mode/',
    userbuttons: '/userbuttons/',
    hl7dev: '/hl7dev/',
    hl7event: '/hl7event/',
    hl7locinfo: '/hl7locinfo/',
    hl7resident: '/hl7resident/',
    hl7visit: '/hl7visit/',
    sarapreferences: '/sarapreferences/',
    usercategoryorder: '/usercategoryorder/',
    siteinfo: '/siteinfo/',
    unit: '/unit/',
    saraprofile: '/saraprofile/',
    user: '/user/',
    usereuladata: '/usereuladata/',
    userstatus: '/userstatus/',
    process: '/process/',
    exportUnits: '/unit/export/',
    exportUsers: '/user/export/',
    importUnits: '/unit/upload/',
    importUsers: '/user/upload/?dryrun=0',
    parameters: '/parameters/',
    activetamperreport: '/reports/activetamperreport/',
    missingdevicesreport: '/reports/missingdevicesreport/',
    dormantdevicereport: '/reports/dormantdevicereport/',
    lowbatteryreport: '/reports/lowbatteryreport/',
    asciiConverter: '/support/echostream/decode/',
    fkRepair: '/support/db/fkrepair/',
    asciiRepair: '/support/db/asciirepair/',
    queryCatalog: '/support/db/query/',
    auditLogs:'/reports/auditlog',
    assignDevices:'/autoassign/',
    documentandimages: '/media/docnode/',
    forgotPassword: '/forgotpassword/',
    resetpassword: '/resetpassword/',
    forgotUsername: '/forgotusername/',
    
  },
};
